import React, { useState, useEffect, useRef, memo } from "react";
import { HTTP } from "../../api/http-common";
import { useNavigate, Link } from "react-router-dom";
import { isValidEmail } from '../../component/common';
import { CircleX, Trash } from "lucide-react";
import Swal from 'sweetalert2'
import { useGlobalContext } from "./../../component/GlobalContext";
import VendorGalleryView from "./VendorGalleryView";

function VendorGalleryAdd() {
  const navigate = useNavigate();

  const [file, setFile] = useState(null);
  const fileInputRef = useRef(null);
  const [description, setDescription] = useState('');
  const [bannerImage, setBannerImage] = useState(null); // State for the banner image
  const [preview, setPreview] = useState(null); // State for image preview
  const [descriptionError, setDescriptionError] = useState("");
  const [fileError, setFileError] = useState("");
  const [galleryList, setGalleryList] = useState([]);
  const [isDragging, setIsDragging] = useState(false); // State to indicate dragging

  // const handleFileChange = (e) => {
  //   setFile(e.target.files[0]);
  // };

  // const handleFileChange = (event, fieldName) => {
  //   const file = event.target.files[0];
  //   if (file) {
  //     const reader = new FileReader();

  //     reader.onloadend = () => {
  //       setPreview(reader.result); // Set preview URL for the image
  //     };

  //     reader.readAsDataURL(file); // Read file as Data URL for image preview

  //     if (fieldName === "file") {
  //       setFile(file); // Set file for the main image
  //     } else if (fieldName === "banner_image") {
  //       setBannerImage(file); // Set file for the banner image
  //     }
  //   }
  // };
  const handleDrop = (event) => {
    event.preventDefault();
    setIsDragging(false); // Reset dragging state
    const droppedFile = event.dataTransfer.files[0];
    if (droppedFile) {
      handleFileChange(droppedFile); // Process the dropped file
    }
  };
  const handleDragOver = (event) => {
    event.preventDefault();
    setIsDragging(true); // Set dragging state to true
  };

  const handleDragLeave = () => {
    setIsDragging(false); // Reset dragging state when leaving drop area
  };

  const handleFileChange = (file, event, fieldName) => {
    if (file) {
      const reader = new FileReader();

      reader.onloadend = () => {
        setPreview(reader.result); // Set preview URL for the image
      };
      if (fieldName === "file") {
        setFile(file); // Set file for the main image
      } else if (fieldName === "banner_image") {
        setBannerImage(file); // Set file for the banner image
      }
      reader.readAsDataURL(file); // Read file as Data URL for image preview
      setFile(file); // Set file for the main image
    }
  };

  const handleInputChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      handleFileChange(selectedFile); // Process the selected file
    }
  };

  const handleCancelUpload = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!"
    }).then((result) => {
      if (result.isConfirmed) {
        setFile(null);
        setPreview(null);
        Swal.fire("Removed!", "Your image has been removed.", "success");
      }
    });
  };

  const handleClick = () => {
    fileInputRef.current.click(); // Trigger the file input on click
  };

  useEffect(() => {
    loadGalleryList();
  }, []);
  const loadGalleryList = async () => {
    const access_token = localStorage.getItem('access_token');
    const config = {
      headers: { 'Content-Type': 'application/json', 'token': access_token },
    };
    let fields = {

    };
    HTTP.post("/vendors/gallery/list", fields, config)
      .then((response) => {
        const data = response.data;
        if (response.status === 200) {
          setGalleryList(data.contents);
        }
        // console.log("data for image", data);
      })
      .catch((error) => {
        // console.log(error);
        if (error.response && error.response.status === 401) {
          // Handle unauthorized error
          localStorage.clear();
          navigate('/'); // Redirect to login page
        }

      });
  }


  const resetValidationErrors = () => {
    // For Address
    setDescriptionError('');
    setFileError('');
  };
  const resetForm = () => {
    resetValidationErrors()
    // setFile('');
    setFile(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = ''; // This will reset the input
    }
    setDescription('');
  };
  const validateField = () => {
    resetValidationErrors();

    let checked = true;


    //For Address 

    if (description === '') {
      setDescriptionError('Please enter description');
      if (checked) {
        checked = false;
      }
    } else if (description.length < 5) {
      setDescriptionError("Please enter minimum 5 characters");
      if (checked) {
        checked = false;
      }
    } else {
      setDescriptionError(""); // Clear error if validation passes
    }

    // Check file size (5MB limit)
    const maxSize = 5 * 1024 * 1024; // 5MB in bytes
    // Check file type (only images allowed)
    const allowedTypes = ["image/jpeg", "image/png", "image/gif"];
    if (!file) {
      // alert("Please select a file first.");
      setFileError("Please select a file first.");
      if (checked) {
        checked = false;
      }
    } else if (file.size > maxSize) {
      setFileError("File size exceeds 5MB.");
      if (checked) {
        checked = false;
      }
    } else if (!allowedTypes.includes(file.type)) {
      setFileError("Only image files (JPG, PNG, GIF) are allowed.");
      if (checked) {
        checked = false;
      }
    }

    return checked;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateField()) {
      try {
        const access_token = localStorage.getItem('access_token');
        let config = {
          headers: { "Content-Type": "multipart/form-data", token: access_token },
        };
        // if (!file || !bannerImage) {
        //   setFileError("Both file and banner image are required.");
        //   return;
        // }
        const formData = new FormData();
        formData.append("description", description);
        formData.append("file", file);
        formData.append("banner_image", bannerImage);

        await HTTP.post(
          "/vendors/gallery/add",
          formData,
          config
        )
          .then(async (response) => {
            if (response.status === 200) {
              Swal.fire({
                title: 'Gallery image added successfully!',
                //   text: "Please verify your email before login",
                icon: "success"
              });
              resetForm()
              setPreview(null);
              loadGalleryList()
            }
          })
          .catch((error) => {
            if (error.response.status === 406) {
              resetValidationErrors();
              //   setPasswordError(error.response.data.detail);
              Swal.fire({
                title: 'Error!',
                text: error.response.data.detail,
                icon: 'error',
                confirmButtonText: 'Ok'
              })
            }
            if (error.response.status === 400) {
              Swal.fire({
                title: 'Error!',
                text: 'You are already registered!',
                icon: 'error',
                confirmButtonText: 'Ok'
              })
            }
            if (error.response.status === 422) {
              console.log(error.response)
              // alert('here')
              Swal.fire({
                title: 'Error!',
                text: error.response.data.detail[0].msg + " " + error.response.data.detail[0].input,
                icon: 'error',
                confirmButtonText: 'Ok'
              })
            }
            // setError(error);
            // setRerenderFlag(true);
            // loadAaMasterData();
            // resetValidationErrors();
          });

        // setIsLoading(false);
      } catch (error) {
        // setError(error);
        // setRerenderFlag(true);
        // setIsLoading(false);
      }
    }
  };

  const handleDelete = async (id) => {
    const access_token = localStorage.getItem("access_token");
    const config = {
      headers: { "Content-Type": "application/json", token: access_token },
    };
    try {
      const access_token = localStorage.getItem('access_token');
      let config = {
        headers: { "Content-Type": "application/json", token: access_token },
      };

      // Show confirmation dialog
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "This action cannot be undone!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "Cancel",
      });
      if (result.isConfirmed) {
        await HTTP.delete(
          `vendors/gallery/delete/${id}`,
          config
        )
          .then(async (response) => {
            if (response.status === 200) {
              Swal.fire({
                title: response.data.message,
                //   text: "Please verify your email before login",
                icon: "success"
              });
              loadGalleryList()
              //   setUsermailToVerify(email);
              //   navigate('/verify');
            }
          })
          .catch((error) => {
            if (error.response.status === 406) {
              resetValidationErrors();
              //   setPasswordError(error.response.data.detail);
              Swal.fire({
                title: 'Error!',
                text: error.response.data.detail,
                icon: 'error',
                confirmButtonText: 'Ok'
              })
            }
            if (error.response.status === 400) {
              Swal.fire({
                title: 'Error!',
                text: 'You are already registered!',
                icon: 'error',
                confirmButtonText: 'Ok'
              })
            }
            if (error.response.status === 422) {
              console.log(error.response)
              // alert('here')
              Swal.fire({
                title: 'Error!',
                text: error.response.data.detail[0].msg + " " + error.response.data.detail[0].input,
                icon: 'error',
                confirmButtonText: 'Ok'
              })
            }
          });
        // setIsLoading(false);
      }
    } catch (error) {
    }
  };

  return (
    <>
      <div className="space-y-4 mt-8">
        <div className="bg-white rounded-lg p-6 border-gray-200 border">
          <div className="flex item-center justify-between">
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-24 vendor-gallery-add-image-wrapper">

              <div className="space-y-2">
                <label htmlFor="description" className="text-sm font-semibold">
                  Description
                </label>
                <textarea
                  type="text"
                  id="description"
                  name="description"
                  className="w-full p-3 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
                {descriptionError && <span className="text-sm text-red-500">{descriptionError}</span>}
              </div>

              <div className="space-y-2">
                <span className="flex items-center justify-between">

                  <label htmlFor="file" className="text-sm font-semibold">
                    Upload Image
                  </label>
                  {preview ? (<button
                    onClick={handleCancelUpload}
                    className="cursor-pointer text-red-500 hover:text-red-700"
                  >

                    <CircleX s ize={24} />
                  </button>) : null}
                </span>
                <div
                  className={`border-2 ${isDragging ? 'border-blue-400' : 'border-gray-400'} border-dashed rounded-lg p-2.5 mt-2 cursor-pointer text-center relative`}
                  onDrop={handleDrop}
                  onDragOver={handleDragOver}
                  onDragLeave={handleDragLeave}
                  onClick={handleClick}
                >
                  <input
                    type="file"
                    id="file"
                    name="file"
                    accept="image/*"
                    className="hidden" // Hide the input element
                    onChange={handleInputChange}
                    ref={fileInputRef}
                  />

                  {preview ? (
                    <div className="relative">
                      {/* Image Preview */}
                      <img src={preview} alt="Preview" className="w-45 h-40 object-cover mx-auto rounded" />

                      {/* Cancel Icon */}
                      {/* <button 
              onClick={handleCancelUpload} 
              className="absolute top-0 right-0 text-red-500 hover:text-red-700"
            >
              
              <CircleX  size={24}/>
            </button> */}
                      <p className="mt-1.5">click to replace the Image</p>
                    </div>
                  ) : (
                    <p className="text-sm text-gray-500">Drag & drop or click to upload an image</p>
                  )}
                </div>

                {fileError && <span className="text-sm text-red-500">{fileError}</span>}

                {file && !preview && (
                  <p className="text-sm text-gray-500 mt-2">
                    You can change the image by clicking on the "Cancel" icon after uploading.
                  </p>
                )}

              </div>

            </div>
          </div>
          <div>&nbsp;</div>
          <button
            type="submit"
            className="theme-button text-white px-4 py-2 rounded-md shadow-sm"
            onClick={handleSubmit}
          >
            Submit
          </button>
        </div>
      </div>

      <div>
        <VendorGalleryView galleryList={galleryList} handleDelete={handleDelete} />
      </div>
    </>
  )
}

export default memo(VendorGalleryAdd);